/**
 * Related WordPress blog articles, keyed by practice-area slug.
 *
 * These posts stay on WordPress at the site root and are served post-cutover via
 * the nginx @wordpress fallback. This map ports the old `mlny-internal-link-booster`
 * mu-plugin hub→spoke wiring into the React practice hubs that REPLACE the WP booster
 * hubs (probate / estate-planning / elder-law), so the link-equity flow from hub down
 * to the high-value long-tail posts is preserved through the migration.
 *
 * All URLs verified live (HTTP 200) on 2026-06-17. Absolute URLs because these are
 * WordPress-served pages, not React routes.
 */
export interface RelatedArticle {
  title: string;
  url: string;
}

const SITE = 'https://www.morganlegalny.com';

export const relatedArticlesByPractice: Record<string, RelatedArticle[]> = {
  probate: [
    {
      title: 'How Do You Become Executor of an Estate After Death in NY?',
      url: `${SITE}/how-do-you-become-executor-of-an-estate-after-death-in-ny/`,
    },
    {
      title: 'What If the Executor Does Not Probate the Will?',
      url: `${SITE}/what-if-the-executor-does-not-probate-the-will/`,
    },
    {
      title: 'Executor Duties in New York — A Complete Guide',
      url: `${SITE}/executor-duties-new-york-guide/`,
    },
    {
      title: 'Who Is the Eldest Next of Kin?',
      url: `${SITE}/who-is-the-eldest-next-of-kin/`,
    },
  ],
  'estate-planning': [
    {
      title: "Bob Saget's Estate Plan Will Bring Tears to Your Eyes",
      url: `${SITE}/bob-sagets-estate-plan-will-bring-tears-to-your-eyes/`,
    },
    {
      title: 'Can You Buy a Will From the Post Office?',
      url: `${SITE}/can-you-buy-a-will-from-the-post-office/`,
    },
    {
      title: 'How Do You Become Executor of an Estate After Death in NY?',
      url: `${SITE}/how-do-you-become-executor-of-an-estate-after-death-in-ny/`,
    },
  ],
  'elder-law': [
    {
      title: 'Where to Apply for Medicaid in Brooklyn',
      url: `${SITE}/where-to-apply-for-medicaid-in-brooklyn/`,
    },
    {
      title: 'Who Is the Eldest Next of Kin?',
      url: `${SITE}/who-is-the-eldest-next-of-kin/`,
    },
    {
      title: 'How Do You Become Executor of an Estate After Death in NY?',
      url: `${SITE}/how-do-you-become-executor-of-an-estate-after-death-in-ny/`,
    },
  ],
};
